
const collections = [
  {
    id: 1,
    name: 'ESMALTES SEMIPERMANENTES',
    image: 'https://public.readdy.ai/ai/img_res/693c5ab2f6bd6842089dcde6e2424253.jpg'
  },
  {
    id: 2,
    name: 'FRESAS Y TORNOS',
    image: 'https://readdy.ai/api/search-image?query=Professional%20electric%20nail%20drill%20machine%20with%20carbide%20drill%20bits%20set%20on%20elegant%20white%20surface%20beauty%20equipment%20and%20tools%20product%20photography&width=400&height=500&seq=col-fresas&orientation=portrait'
  },
  {
    id: 3,
    name: 'LÁMPARAS UV/LED',
    image: 'https://readdy.ai/api/search-image?query=Professional%20UV%20LED%20nail%20lamp%20white%20and%20rose%20gold%20design%20modern%20beauty%20equipment%20on%20clean%20white%20background%20product%20photography&width=400&height=500&seq=col-lamparas&orientation=portrait'
  },
  {
    id: 4,
    name: 'ACCESORIOS PROFESIONALES',
    image: 'https://readdy.ai/api/search-image?query=Professional%20nail%20accessories%20including%20paper%20forms%20brushes%20files%20and%20tools%20arranged%20on%20elegant%20white%20surface%20beauty%20supplies%20product%20photography&width=400&height=500&seq=col-accesorios&orientation=portrait'
  }
];

export default function CollectionsSection() {
  return (
    <section id="colecciones" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-serif font-bold text-center text-stone-900 mb-12">
          COMPRA POR COLECCIÓN
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {collections.map((collection) => (
            <div key={collection.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-[4/5] mb-4">
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
              </div>
              <h3 className="text-center font-semibold text-stone-900 text-sm tracking-wide">
                {collection.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
